import { Component, EventEmitter, Input, Output} from '@angular/core';
import { Meeting } from '../../models/meeting.model';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatRippleModule } from '@angular/material/core';
import { reunionSelectRippleOptions } from '../../constants/ripple-options.constant';

@Component({
  selector: 'app-meeting',
  imports: [CommonModule, TranslateModule, MatRippleModule],
  templateUrl: './meeting.component.html',
  styleUrl: './meeting.component.scss',
})
export class MeetingComponent {
  @Input() meetings: Meeting[] = [];
  @Input() selectedMeetingId?: number;
  @Input() locale: string = 'en-US';
  @Output() reunionSelected = new EventEmitter<number>();
  rippleOptions = reunionSelectRippleOptions
  get stepNumber() {
    return 1;
  }
  selectMeeting(meetingId: number) {
    this.selectedMeetingId = meetingId;
    this.reunionSelected.emit(meetingId);
  }

  formateDate(date: string | number){
    let event = new Date(date);

    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return event.toLocaleDateString(this.locale, options)
  }
}
